import moment from 'moment';
import constants, { DATA_TYPES } from '../constants/CommonConstants';
// import { generateAbandonedFilterObj } from './pipelineUtil';
import {
  ARCHIVED_FILTER_OBJ,
  CHURNED_FILTER_OBJ,
} from '../constants/FilterListConstants';

export const stringFilter = (value, filter) => {
  switch (filter.filter) {
    case 'isSet': {
      return value;
    }
    case 'isNotSet': {
      return !value;
    }
    case 'equals': {
      return filter.value[0] === value;
    }
    case 'contains': {
      return value?.toLowerCase().includes(filter.value[0].toLowerCase());
    }
    default:
      return true;
  }
};

export const dateFilter = (date, filter) => {
  switch (filter.filter) {
    case 'isSet': {
      return date;
    }
    case 'isNotSet': {
      return !date;
    }
    case 'equals': {
      return date && moment(date).isSame(moment(filter.value[0]), 'day');
    }
    case 'greater': {
      return date && moment(date).isAfter(moment(filter.value[0]), 'day');
    }
    case 'lesser': {
      return date && moment(date).isBefore(moment(filter.value[0]), 'day');
    }
    case 'between': {
      return (
        date &&
        moment(date).isBetween(
          moment(filter.value[0]),
          moment(filter.value[1]),
          'day',
          '[]'
        )
      );
    }
    case 'greaterEqual': {
      return date && moment(date).isSameOrAfter(moment(filter.value[0]), 'day');
    }
    case 'lesserEqual': {
      return (
        date && moment(date).isSameOrBefore(moment(filter.value[0]), 'day')
      );
    }
    default:
      return true;
  }
};

export const singlePicklistFilter = (value, filter) => {
  switch (filter.filter) {
    case 'isSet': {
      return value;
    }
    case 'isNotSet': {
      return !value;
    }
    case 'isSetTo': {
      return filter.value.includes(value);
    }
    default:
      return true;
  }
};

export const multiPicklistFilter = (value, filter) => {
  switch (filter.filter) {
    case 'isSet': {
      return value;
    }
    case 'isNotSet': {
      return !value;
    }
    case 'isSetTo': {
      return filter.value.includes(value);
    }
    default:
      return true;
  }
};

export const numberFilter = (value, filter) => {
  switch (filter.filter) {
    case 'isSet':
      return value !== undefined;
    case 'isNotSet':
      return !value && value !== 0;
    case 'greater':
      return +value > +filter.value[0];
    case 'lesser':
      return +value < +filter.value[0];
    case 'greaterEqual':
      return +value >= +filter.value[0];
    case 'lesserEqual':
      return +value <= +filter.value[0];
    case 'equals':
    default:
      return +value === +filter.value[0];
  }
};

export const convertLocalDateTimeToUTCInFilters = (filters) =>
  filters.map((filter) => {
    const { attribute, value, filter: filterType } = filter;
    const showTime = attribute.dateOptions?.showTime;
    return [DATA_TYPES.date, DATA_TYPES.mandatoryDate].includes(
      attribute.dataType
    )
      ? {
          ...filter,
          value: value.map(
            (date) =>
              (showTime?.for?.includes(filterType) && moment(date).utc()) ||
              date
          ),
        }
      : filter;
  });

// eslint-disable-next-line no-unused-vars
export const generateDefaultAppliedFilterList = (pipelineStatusIds = null) => {
  // DEV TO DO: Commenting this because this needs to be fixed as  HF @Newumal @Shayne @Mehani
  // const abandonedFilterObj = generateAbandonedFilterObj(pipelineStatusIds);

  return {
    [constants.ORGANIZATION_LEVEL]: [ARCHIVED_FILTER_OBJ, CHURNED_FILTER_OBJ],
    [constants.ACCOUNT_LEVEL]: [ARCHIVED_FILTER_OBJ, CHURNED_FILTER_OBJ],
    [constants.CONTACT_LEVEL]: [ARCHIVED_FILTER_OBJ],
    [constants.PIPELINE_LEVEL]: [ARCHIVED_FILTER_OBJ],
    [constants.CUSTOM_OBJECT_LEVEL]: [ARCHIVED_FILTER_OBJ],
  };
};
